import { render } from "./NewSeparateLectionPreview.vue?vue&type=template&id=645e0350&scoped=true"
import script from "./NewSeparateLectionPreview.vue?vue&type=script&lang=js"
export * from "./NewSeparateLectionPreview.vue?vue&type=script&lang=js"

import "./NewSeparateLectionPreview.vue?vue&type=style&index=0&id=645e0350&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645e0350"]])

export default __exports__